import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/app_logo.webp")